import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetInventoryTransactionsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.InventoryTransactionDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.InventoryTransactionDocumentSortInput> | Types.InventoryTransactionDocumentSortInput>;
}>;


export type GetInventoryTransactionsQuery = { __typename?: 'Query', inventoryTransactions?: { __typename?: 'InventoryTransactionsConnection', totalCount: number, nodes?: Array<{ __typename?: 'InventoryTransactionDocument', counterpartItemId?: string | null, counterpartLocationId?: string | null, counterpartSku?: string | null, grade: number, id: string, itemId: string, itemName: string, locationId: string, locationName: string, previousQuantity: number, quantity: number, reasonCode: string, sku: string, tenantId: string, timestamp: Types.TDateISO, transactionType: Types.InventoryTransactionType, transferId?: string | null, userId: string, why: string, batchMovements: Array<{ __typename?: 'InventoryTransactionBatchDocument', code: string, sourceKind: Types.BatchSourceKind, ageDate?: string | null, quantity: number }>, itemShippingUom?: { __typename?: 'InventoryTransactionShippingUomData', code: string, eachesPerUnit?: number | null, label: string } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetInventoryTransactionsForKeyQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  where?: Types.InputMaybe<Types.InventoryTransactionDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.InventoryTransactionDocumentSortInput> | Types.InventoryTransactionDocumentSortInput>;
}>;


export type GetInventoryTransactionsForKeyQuery = { __typename?: 'Query', inventoryTransactions?: { __typename?: 'InventoryTransactionsConnection', totalCount: number, nodes?: Array<{ __typename?: 'InventoryTransactionDocument', counterpartItemId?: string | null, counterpartLocationId?: string | null, counterpartSku?: string | null, grade: number, id: string, itemId: string, itemName: string, locationId: string, locationName: string, previousQuantity: number, quantity: number, reasonCode: string, sku: string, tenantId: string, timestamp: Types.TDateISO, transactionType: Types.InventoryTransactionType, transferId?: string | null, userId: string, why: string, batchMovements: Array<{ __typename?: 'InventoryTransactionBatchDocument', code: string, sourceKind: Types.BatchSourceKind, ageDate?: string | null, quantity: number }>, itemShippingUom?: { __typename?: 'InventoryTransactionShippingUomData', code: string, eachesPerUnit?: number | null, label: string } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type InventoryTransactionDetailsFragment = { __typename?: 'InventoryTransactionDocument', counterpartItemId?: string | null, counterpartLocationId?: string | null, counterpartSku?: string | null, grade: number, id: string, itemId: string, itemName: string, locationId: string, locationName: string, previousQuantity: number, quantity: number, reasonCode: string, sku: string, tenantId: string, timestamp: Types.TDateISO, transactionType: Types.InventoryTransactionType, transferId?: string | null, userId: string, why: string, batchMovements: Array<{ __typename?: 'InventoryTransactionBatchDocument', code: string, sourceKind: Types.BatchSourceKind, ageDate?: string | null, quantity: number }>, itemShippingUom?: { __typename?: 'InventoryTransactionShippingUomData', code: string, eachesPerUnit?: number | null, label: string } | null };

export const InventoryTransactionDetailsFragmentDoc = new TypedDocumentString(`
    fragment InventoryTransactionDetails on InventoryTransactionDocument {
  batchMovements {
    code
    sourceKind
    ageDate
    quantity
  }
  counterpartItemId
  counterpartLocationId
  counterpartSku
  grade
  id
  itemId
  itemName
  itemShippingUom {
    code
    eachesPerUnit
    label
  }
  locationId
  locationName
  previousQuantity
  quantity
  reasonCode
  sku
  tenantId
  timestamp
  transactionType
  transferId
  userId
  why
}
    `, {"fragmentName":"InventoryTransactionDetails"});
export const GetInventoryTransactionsDocument = new TypedDocumentString(`
    query GetInventoryTransactions($first: Int, $after: String, $last: Int, $before: String, $where: InventoryTransactionDocumentFilterInput, $order: [InventoryTransactionDocumentSortInput!]) {
  inventoryTransactions(
    first: $first
    after: $after
    last: $last
    before: $before
    where: $where
    order: $order
  ) {
    nodes {
      ...InventoryTransactionDetails
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment InventoryTransactionDetails on InventoryTransactionDocument {
  batchMovements {
    code
    sourceKind
    ageDate
    quantity
  }
  counterpartItemId
  counterpartLocationId
  counterpartSku
  grade
  id
  itemId
  itemName
  itemShippingUom {
    code
    eachesPerUnit
    label
  }
  locationId
  locationName
  previousQuantity
  quantity
  reasonCode
  sku
  tenantId
  timestamp
  transactionType
  transferId
  userId
  why
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetInventoryTransactionsForKeyDocument = new TypedDocumentString(`
    query GetInventoryTransactionsForKey($first: Int, $where: InventoryTransactionDocumentFilterInput, $order: [InventoryTransactionDocumentSortInput!]) {
  inventoryTransactions(first: $first, where: $where, order: $order) {
    nodes {
      ...InventoryTransactionDetails
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment InventoryTransactionDetails on InventoryTransactionDocument {
  batchMovements {
    code
    sourceKind
    ageDate
    quantity
  }
  counterpartItemId
  counterpartLocationId
  counterpartSku
  grade
  id
  itemId
  itemName
  itemShippingUom {
    code
    eachesPerUnit
    label
  }
  locationId
  locationName
  previousQuantity
  quantity
  reasonCode
  sku
  tenantId
  timestamp
  transactionType
  transferId
  userId
  why
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetInventoryTransactions: build.query<GetInventoryTransactionsQuery, GetInventoryTransactionsQueryVariables | void>({
      query: (variables) => ({ document: GetInventoryTransactionsDocument, variables })
    }),
    GetInventoryTransactionsForKey: build.query<GetInventoryTransactionsForKeyQuery, GetInventoryTransactionsForKeyQueryVariables | void>({
      query: (variables) => ({ document: GetInventoryTransactionsForKeyDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetInventoryTransactionsQuery, useLazyGetInventoryTransactionsQuery, useGetInventoryTransactionsForKeyQuery, useLazyGetInventoryTransactionsForKeyQuery } = injectedRtkApi;
